// Story 100 (S104, RN47 + DN-7): the returned population's period filter is FREE (no upper bound,
// DN-34) but defaults to the last thirty days (DN-7) -- pagination on the server is what actually
// protects the volume, not a capped filter.
export const DEFAULT_PERIOD_DAYS = 30
const MS_PER_DAY = 24 * 60 * 60 * 1000

/**
 * @param {Date} [referenceDate] - defaults to "now"
 * @returns {Date} thirty days before the reference date
 */
export const defaultFromDate = (referenceDate = new Date()) =>
  new Date(referenceDate.getTime() - DEFAULT_PERIOD_DAYS * MS_PER_DAY)

/** Formats a Date as the value a `<input type="date">` expects (YYYY-MM-DD, UTC). */
export const toDateInputValue = (date) => date.toISOString().slice(0, 10)

/** Parses a `<input type="date">` value (YYYY-MM-DD) back into a Date at UTC midnight. */
export const fromDateInputValue = (value) => new Date(`${value}T00:00:00.000Z`)
